/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	class MissingOriginalCustomGroupItemId extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1403;
		}

		/**
		 * Perform upgrade to add "originalCustomGroupItemId" to the dataItem when it represents a custom group
		 * @param {object} spec - spec to perform upgrade on
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			return this._upgradeWidgets(spec);

		}

		down(spec) {
			// Downgrades are not available in CA
			return Promise.resolve(spec);
		}

		_upgradeWidgets(spec) {
			_.each(spec.widgets, model => {
				this._upgradeWidget(model, spec);
			});
			return Promise.resolve(spec);
		}

		_upgradeWidget(model, spec) {
			_.each(model.data && model.data.dataViews, dataView => {
				const moduleId = dataView.modelRef;
				const dataItems = dataView.dataItems;
				const dataSources = spec.dataSources;
				this._setOriginalCustomGroupItemId(dataSources && dataSources.sources, moduleId, dataItems);
			});
		}

		_setOriginalCustomGroupItemId(sources, moduleId, dataItems) {
			const source = _.findWhere(sources, { id: moduleId } );
			if (source) {
				const moserJSON = source.shaping && source.shaping.moserJSON;
				const calculations = moserJSON && moserJSON.calculation;
				_.each(dataItems, dataItem => {
					const calculation = _.findWhere(calculations, { identifier: dataItem.itemId });
					if (calculation) {
						const uiExprProperties = _.where(calculation.property, { name: 'ui_expr' });
						if (uiExprProperties) {
							_.find(uiExprProperties, property => {
								const value = JSON.parse(property.value);
								if (value.func === 'customGroup') {
									dataItem.originalCustomGroupItemId = value.basedOnMoserObject;
									return true;
								}
							});
						}
					}
				});
			}
		}

	}

	return new MissingOriginalCustomGroupItemId();

});
